import {LocalisedPropertyValue, RequiredLanguageProfile} from '../../../../types/shared-types';

export interface CompanyWorkforceProfileDepartment {
  resourceId: string;
  name: string | RequiredLanguageProfile | Partial<RequiredLanguageProfile>;
}

export interface CompanyWorkforceProfileTargetProfile {
  resourceId: string;
  title: string;
}

export interface WorkforceProfileAlignmentScores {
  overall?: number | null;
  coreCompetencies?: number | null;
  hardSkills?: number | null;
  tools?: number | null;
  domainKnowledge?: number | null;
  softSkills?: number | null;
  responsibilities?: number | null;
  culturalFit?: number | null;
}

export type SeniorityLevelDelta = 'at' | 'above' | 'below' | 'uncertain';

export interface WorkforceProfileSeniorityLevelAssessment {
  assignedSeniority: string | null;
  evidencedLevel: string | null;
  levelDelta: SeniorityLevelDelta;
  explanation: string;
}

export interface WorkforceProfileHighlights {
  strong: string[];
  gaps: string[];
  strengths: string[];
}

export interface WorkforceProfileCompetencyRow {
  name: string;
  nameEn?: string;
  nameDe?: string;
  met: boolean;
  explanation?: string | null;
}

export const hasLocalizedText = (text: LocalisedPropertyValue | null | undefined): boolean =>
  !!(text?.en?.trim() || text?.de?.trim());
